namespace TabAurous.ECommerce {
    export interface ECommSalesReturnItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        AttributeId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        VoucherNo?: string;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        OrderStatusId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        MF?: number;
        MFAmount?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        BOMDetails?: ECommSalesReturnItemsBOMRow[];
        LaborDetails?: ECommSalesReturnLaborRow[];
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        StockAllocation?: boolean;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        MetalId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
    }

    export namespace ECommSalesReturnItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ECommerce.ECommSalesReturnItems';
        export const deletePermission = 'EComm:ECommSalesReturn:Delete';
        export const insertPermission = 'EComm:ECommSalesReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSalesReturn:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            AttributeId = "AttributeId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            VoucherNo = "VoucherNo",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            OrderStatusId = "OrderStatusId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MF = "MF",
            MFAmount = "MFAmount",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            StockAllocation = "StockAllocation",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            MetalId = "MetalId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab"
        }
    }
}
